const Warigaki = {
    elemName: '割書',
    type: 'inline',
    doc: '割書を挿入します。"｜"で区切られた各テキストが行になります。',
    example: '《割書：一行目｜二行目｜三行目》',
    minContentCount: 2,
    maxContentCount: 4,
    textTemplate: "（{{$0.join('／')}}）",
    htmlTemplate: `
	<span {{{$htmlId}}} class="Warigaki {{$classes}}">
		{{#$0}}
		<span class="warigaki-line">{{{.}}}</span>
		{{/$0}}
	</span>
	`,
    xmlTemplate: `
	<note type="wari">
		{{#$0}}
		{{{.}}}<milestone unit="wrb"/>
		{{/$0}}
	</note>
	`,
    docxTemplate: `
	<w:r>
        <w:rPr>
          <w:rFonts w:hint="eastAsia"/>
          <w:eastAsianLayout w:combine="1"/>
        </w:rPr>
        <w:t>{{{$$1}}}{{{$$2}}}
        </w:t>
    </w:r>
	`,
    latexTemplate: '{{#$3}} {{#$4}} \\yongyouwari{ {{{$1}}} }{ {{{$2}}} }{ {{{$3}}} }{ {{{$4}}} } {{/$4}} {{^$4}} \\sangyouwari{ {{{$1}}} }{ {{{$2}}} }{ {{{$3}}} } {{/$4}} {{/$3}} {{^$3}}\\sougyou{ {{{$1}}} }{ {{{$2}}} } {{/$3}}'
};
export default Warigaki;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2FyaWdha2kuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9XYXJpZ2FraS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLFFBQVEsR0FBbUI7SUFDaEMsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxpQ0FBaUM7SUFDdEMsT0FBTyxFQUFFLGtCQUFrQjtJQUMzQixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsb0JBQW9CO0lBQ2xDLFlBQVksRUFBRTs7Ozs7O0VBTWI7SUFDRCxXQUFXLEVBQUU7Ozs7OztFQU1aO0lBQ0QsWUFBWSxFQUFFOzs7Ozs7Ozs7RUFTYjtJQUNELGFBQWEsRUFBRSxrTkFBa047Q0FDak8sQ0FBQztBQUVGLGVBQWUsUUFBUSxDQUFDIn0=